export const getMobileNumber = (phone, callingCode) => {
  const callingCodeWithoutPlus = callingCode?.replace('+', '');
  const combinedNumber = phone?.replace(callingCodeWithoutPlus, '');
  const phoneNumber = combinedNumber.replace(/\s/g, '');
  return phoneNumber;
};
